import { useEffect, useState } from "react";

import authorImage from "../../assets/Asman_PIc-Copy.jpeg";

import thumbnailImage from "../../assets/blog_images/ReconnaissanceTechniquesInPenetratingTesting/thumbnail.png";
import whoisImage from "../../assets/blog_images/ReconnaissanceTechniquesInPenetratingTesting/2.png";
import virustotalImage from "../../assets/blog_images/ReconnaissanceTechniquesInPenetratingTesting/3.png";
import waybackImage from "../../assets/blog_images/ReconnaissanceTechniquesInPenetratingTesting/4.png";
import hunterImage from "../../assets/blog_images/ReconnaissanceTechniquesInPenetratingTesting/5.png";
import mxToolboxImage from "../../assets/blog_images/ReconnaissanceTechniquesInPenetratingTesting/6.png";
import dnsCheckerImage from "../../assets/blog_images/ReconnaissanceTechniquesInPenetratingTesting/7.png";
import shodanImage from "../../assets/blog_images/ReconnaissanceTechniquesInPenetratingTesting/8.png";
import pingImage from "../../assets/blog_images/ReconnaissanceTechniquesInPenetratingTesting/9.png";
import whatWebImage from "../../assets/blog_images/ReconnaissanceTechniquesInPenetratingTesting/10.png";
import nmapImage from "../../assets/blog_images/ReconnaissanceTechniquesInPenetratingTesting/11.png";
import wappalyzerImage from "../../assets/blog_images/ReconnaissanceTechniquesInPenetratingTesting/12.png";
import urlFuzzerImage from "../../assets/blog_images/ReconnaissanceTechniquesInPenetratingTesting/13.png";

import sqlInjectionImage from "../../assets/blog_images/sqlInjection/sql_injection1.jpg";
import brokenAccessImage from "../../assets/blog_images/BrokenAccessControllAuthentication/brokenThumbnail.png";
import sessionImage from "../../assets/blog_images/sessionManagement/session1.png";

const SUPPORT_WHATSAPP_NUMBER = "919080432374";
const SUPPORT_MESSAGE = "Hi, I am Looking for Cyber Security Training";

function ReconnaissanceInPenetrationTesting() {
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [shareModalOpen1, setShareModalOpen1] = useState(false);
  const [whatsappOpen, setWhatsappOpen] = useState(false);
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    document.title = "Reconnaissance In Penetrating Testing";

    function handleScroll() {
      setShowBackToTop(window.scrollY > 300);
    }

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function openWhatsAppChat() {
    const encoded = encodeURIComponent(SUPPORT_MESSAGE);
    const waMe = `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${encoded}`;
    window.open(waMe, "_blank", "noopener,noreferrer");
  }

  function openWhatsAppAppFallback() {
    const encoded = encodeURIComponent(SUPPORT_MESSAGE);
    const deepLink = `whatsapp://send?phone=${SUPPORT_WHATSAPP_NUMBER}&text=${encoded}`;
    const webLink = `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${encoded}`;

    window.location.href = deepLink;

    setTimeout(() => {
      window.open(webLink, "_blank", "noopener,noreferrer");
    }, 700);
  }

  return (
    <main className="overflow-x-hidden bg-white">
      <section className="w-full max-w-5xl px-4 py-10 mx-auto overflow-x-hidden bg-white">
        <article className="article post tag-hackthebox image-small">
          <header className="article-header gh-canvas">
            <div className="mb-2 article-tag post-card-tags">
              <span className="post-card-primary-tag">
                <a href="" className="text-blue-600">
                  WebApplicationSecurity
                </a>
              </span>
            </div>

            <h1 className="mb-4 text-4xl font-semibold article-title">
              Reconnaissance Techniques in Penetration Testing: A Hands-On
              Approach
            </h1>

            <p className="mb-6 text-lg text-gray-800 article-excerpt">
              <strong>Reconnaissance</strong>, also referred to as{" "}
              <strong>foot printing</strong>, is the initial phase of ethical
              hacking. During this stage, pentesters collect information about a
              target system, application, or organization to identify potential
              vulnerabilities and attack surfaces. The goal is to build a
              detailed profile of the target using both passive and active
              techniques. This intelligence helps guide and prepare for the next
              phases of penetration testing by revealing weaknesses that could
              be exploited.
            </p>

            {/* Article Author Info */}
            <div className="flex flex-col items-start justify-between mb-6 sm:flex-row sm:items-center">
              {/* Left Section */}
              <div className="flex items-start gap-4">
                <img
                  className="w-12 h-12 rounded-full"
                  src={authorImage}
                  alt="Asman"
                />

                <div>
                  <h4 className="text-lg font-semibold">
                    <a href="">Asman</a>
                  </h4>

                  <div className="text-sm font-medium text-gray-500">
                    <time dateTime="2025-05-03">June 18, 2025</time>
                    <span className="ml-1">• 10 min read</span>
                  </div>
                </div>
              </div>

              {/* Right Section: Share Icon */}
              <button
                type="button"
                onClick={() => setShareModalOpen(true)}
                className="mt-5 ml-2 text-2xl text-gray-700 cursor-pointer font-bild hover:text-black"
              >
                {/* Share Icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-8 h-8 fill-current"
                  viewBox="0 0 24 24"
                >
                  <path
                    fillRule="evenodd"
                    d="M15.218 4.931a.4.4 0 0 1-.118.132l.012.006a.45.45 0 0 1-.292.074.5.5 0 0 1-.3-.13l-2.02-2.02v7.07c0 .28-.23.5-.5.5s-.5-.22-.5-.5v-7.04l-2 2a.45.45 0 0 1-.57.04h-.02a.4.4 0 0 1-.16-.3.4.4 0 0 1 .1-.32l2.8-2.8a.5.5 0 0 1 .7 0l2.8 2.79a.42.42 0 0 1 .068.498m-.106.138.008.004v-.01zM16 7.063h1.5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-11c-1.1 0-2-.9-2-2v-10a2 2 0 0 1 2-2H8a.5.5 0 0 1 .35.15.5.5 0 0 1 .15.35.5.5 0 0 1-.15.35.5.5 0 0 1-.35.15H6.4c-.5 0-.9.4-.9.9v10.2a.9.9 0 0 0 .9.9h11.2c.5 0 .9-.4.9-.9v-10.2c0-.5-.4-.9-.9-.9H16a.5.5 0 0 1 0-1"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </button>
            </div>

            {/* Share Modal */}
            {shareModalOpen && (
              <div
                className="fixed inset-0 z-50 flex items-center justify-center bg-opacity-50"
                onClick={(event) => {
                  if (event.target === event.currentTarget) {
                    setShareModalOpen(false);
                  }
                }}
              >
                <div className="p-6 text-black bg-gray-200 rounded-md w-80">
                  <h2 className="mb-4 text-lg font-semibold">
                    Share this article
                  </h2>

                  <div className="flex items-center justify-around">
                    {/* X / Twitter */}
                    <a
                      href="https://twitter.com/intent/tweet?text=https://www.practicalinfosec.com/sqlInjection"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-blue-500"
                    >
                      <svg className="w-10 h-10 fill-current" viewBox="0 0 24 24">
                        <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53A4.48 4.48 0 0 0 22.43.36a9 9 0 0 1-2.83 1.08A4.52 4.52 0 0 0 16.11 0c-2.63 0-4.64 2.24-4.04 4.79A12.94 12.94 0 0 1 1.64 1.14a4.52 4.52 0 0 0-.61 2.27 4.5 4.5 0 0 0 2 3.75 4.41 4.41 0 0 1-2.06-.56v.06a4.53 4.53 0 0 0 3.63 4.43 4.52 4.52 0 0 1-2.04.08 4.53 4.53 0 0 0 4.22 3.14A9.05 9.05 0 0 1 0 19.54a12.93 12.93 0 0 0 7 2.05c8.4 0 13-7.5 12.68-14.23A9.18 9.18 0 0 0 23 3z" />
                      </svg>
                    </a>

                    {/* Facebook */}
                    <a
                      href="https://www.facebook.com/sharer/sharer.php?u=https://www.practicalinfosec.com/sqlInjection"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-blue-700"
                    >
                      <svg className="w-8 h-8 fill-current" viewBox="0 0 24 24">
                        <path d="M22.675 0h-21.35C.592 0 0 .593 0 1.326v21.348C0 23.408.592 24 1.325 24H12.82V14.708h-3.293V11.17h3.293V8.413c0-3.26 1.986-5.038 4.89-5.038 1.39 0 2.585.104 2.933.15v3.4l-2.013.001c-1.577 0-1.883.75-1.883 1.85v2.43h3.766l-.491 3.538h-3.275V24h6.42C23.408 24 24 23.408 24 22.675V1.325C24 .593 23.408 0 22.675 0z" />
                      </svg>
                    </a>

                    {/* LinkedIn */}
                    <a
                      href="https://www.linkedin.com/sharing/share-offsite/?url=https://www.practicalinfosec.com/sqlInjection"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-blue-600"
                    >
                      <svg className="w-8 h-8 fill-current" viewBox="0 0 24 24">
                        <path d="M20.447 20.452H17.24V14.8c0-1.345-.025-3.078-1.879-3.078-1.88 0-2.168 1.464-2.168 2.976v5.753h-3.207V9h3.076v1.561h.043c.429-.811 1.476-1.666 3.036-1.666 3.246 0 3.844 2.137 3.844 4.917v6.64zM5.337 7.433c-1.034 0-1.873-.839-1.873-1.874 0-1.034.839-1.873 1.873-1.873 1.036 0 1.875.839 1.875 1.873s-.839 1.874-1.875 1.874zM6.789 20.452H3.885V9h2.904v11.452zM22.225 0H1.771C.791 0 0 .77 0 1.723v20.555C0 23.23.79 24 1.771 24h20.451C23.21 24 24 23.23 24 22.278V1.723C24 .77 23.21 0 22.225 0z" />
                      </svg>
                    </a>
                  </div>

                  <button
                    type="button"
                    onClick={() => setShareModalOpen(false)}
                    className="block mx-auto mt-4 text-sm text-gray-600 underline hover:text-black"
                  >
                    Close
                  </button>
                </div>
              </div>
            )}

            <figure className="mb-6 article-image">
              <img
                src={thumbnailImage}
                alt="Sql Injection"
                className="w-full rounded-lg"
              />
            </figure>
          </header>

          <section className="gh-content gh-canvas">
            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              Types of Reconnaissance
            </h2>

            <p className="mb-4 text-lg">
              Reconnaissance in ethical hacking is divided into two main
              categories based on the method of information gathering:
            </p>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              1. Passive Reconnaissance
            </h2>

            <p className="mb-4 text-lg">
              Passive reconnaissance focuses on collecting data from publicly
              accessible sources without alerting the target.
            </p>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              Key Methods:
            </h2>

            <ul className="space-y-2 text-gray-800 list-disc list-inside">
              <li className="ml-6 text-lg">
                <strong>OSINT (Open-Source Intelligence)</strong> Utilizing
                publicly available information such as social media profiles,
                job postings, and news articles.
              </li>

              <li className="ml-6 text-lg">
                <strong>WHOIS Lookup:</strong> Gathering details about domain
                registrations, including ownership and contact information.
              </li>

              <li className="ml-6 text-lg">
                <strong>Social Engineering:</strong> Observing publicly shared
                details that could be leveraged in attacks.
              </li>
            </ul>

            <h2 id="network-scan" className="mt-3 mb-4 text-3xl font-semibold">
              Popular Tools for Passive Reconnaissance:
            </h2>

            <ul className="space-y-2 text-gray-800 list-disc list-inside">
              <li className="ml-6 text-lg">
                <strong>Maltego:</strong> Visualizes relationships between data
                points.
              </li>

              <li className="ml-6 text-lg">
                <strong>Recon-ng:</strong> A modular framework for gathering
                OSINT.
              </li>

              <li className="ml-6 text-lg">
                <strong>Shodan:</strong> A search engine for internet-connected
                devices.
              </li>

              <li className="ml-6 text-lg">
                <strong>Google Dorks:</strong> Advanced search queries to find
                hidden information.
              </li>
            </ul>

            <h2 id="network-scan" className="mt-2 mb-4 text-3xl font-semibold">
              2. Active Reconnaissance
            </h2>

            <p className="mb-4 text-lg">
              Active reconnaissance involves directly engaging with the target
              system to gather in-depth and precise information.
            </p>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              Common Techniques:
            </h2>

            <ul className="space-y-2 text-gray-800 list-disc list-inside">
              <li className="ml-6 text-lg">
                <strong>Network Scanning:</strong> Detects active devices, open
                ports, and available services using tools like Nmap.
              </li>

              <li className="ml-6 text-lg">
                <strong>DNS Interrogation:</strong> Gathers DNS records (A, MX,
                TXT, etc.) to learn more about domain configurations.
              </li>

              <li className="ml-6 text-lg">
                <strong>Banner Grabbing:</strong> Retrieves service banners to
                identify software types and versions.
              </li>
            </ul>

            <h2 id="network-scan" className="mt-2 mb-4 text-3xl font-semibold">
              Popular Tools for Active Reconnaissance:
            </h2>

            <ul className="space-y-2 text-gray-800 list-disc list-inside">
              <li className="ml-6 text-lg">
                <strong>Nmap:</strong> Comprehensive tool for scanning networks
                and discovering hosts and services.
              </li>

              <li className="ml-6 text-lg">
                <strong>Netcat:</strong> Versatile utility for testing and
                interacting with open ports.
              </li>

              <li className="ml-6 text-lg">
                <strong>Metasploit Framework:</strong> A powerful platform for
                vulnerability assessment and exploitation.
              </li>

              <li className="ml-6 text-lg">
                <strong>Dig & Nslookup:</strong> Command-line utilities for
                performing DNS lookups and extracting domain-related data.
              </li>
            </ul>

            <h2 id="network-scan" className="mt-2 mb-4 text-3xl font-semibold">
              Why is Information Gathering Important?
            </h2>

            <ul className="space-y-2 text-gray-800 list-disc list-inside">
              <li className="ml-6 text-lg">
                <strong>1. Understanding the Attack Surface:</strong>{" "}
                Identifying potential entry points that attackers could exploit.
              </li>

              <li className="ml-6 text-lg">
                <strong>2. Improved Risk Assessment:</strong> Gaining insights
                into vulnerabilities and threats specific to the target
                environment.
              </li>

              <li className="ml-6 text-lg">
                <strong>3. Enhanced Defence Strategies:</strong> Crafting
                targeted measures to mitigate identified risks.
              </li>

              <li className="ml-6 text-lg">
                <strong>4. Legal and Ethical Investigations:</strong> Supporting
                ethical hacking, penetration testing, and digital forensics.
              </li>
            </ul>

            <h2 id="network-scan" className="mt-2 mb-4 text-3xl font-semibold">
              Methods of Reconnaissance
            </h2>

            <p className="mb-4 text-lg">
              Reconnaissance is the initial phase of pen testers or penetration
              testing, focused on gathering information about the target system
              or network. It is broadly classified into <strong>passive</strong>{" "}
              and <strong>active</strong> reconnaissance. Below are the key
              methods involved in this phase:
            </p>

            <h2 id="network-scan" className="mt-2 mb-4 text-3xl font-semibold">
              1. Network Mapping
            </h2>

            <p className="mb-4 text-lg">
              Network mapping is the process of visually or logically
              representing the structure of a target network, including
              connected devices, servers, and communication paths.
            </p>

            <h2 id="network-scan" className="mt-2 mb-4 text-2xl font-semibold">
              Purpose:
            </h2>

            <p className="mb-4 text-lg">
              To understand the layout and topology of a network, which helps in
              identifying key assets and potential entry points.
            </p>

            <h2 id="network-scan" className="mt-2 mb-4 text-2xl font-semibold">
              Common Tools:
            </h2>

            <ul className="space-y-2 text-gray-800 list-disc list-inside">
              <li className="ml-6 text-lg">
                <strong>Nmap</strong> (with Zenmap for GUI visualization)
              </li>

              <li className="ml-6 text-lg">
                <strong>SolarWinds Network Topology Mapper</strong>
              </li>

              <li className="ml-6 text-lg">
                <strong>NetBrain</strong>
              </li>

              <li className="ml-6 text-lg">
                <strong>4. Legal and Ethical Investigations:</strong>
              </li>
            </ul>

            <h2 id="network-scan" className="mt-2 mb-4 text-3xl font-semibold">
              2. Footprinting
            </h2>

            <p className="mb-4 text-lg">
              Foot printing involves gathering publicly available information
              about a target organization to create a detailed profile.
            </p>

            <h2 id="network-scan" className="mt-2 mb-4 text-2xl font-semibold">
              Purpose:
            </h2>

            <p className="mb-4 text-lg">
              To identify domain names, IP ranges, external systems, and other
              public infrastructure components.
            </p>

            <h2 id="network-scan" className="mt-2 mb-4 text-2xl font-semibold">
              Common Techniques & Tools:
            </h2>

            <ul className="space-y-2 text-gray-800 list-disc list-inside">
              <li className="ml-6 text-lg">
                <strong>WHOIS Lookup </strong> (e.g., whois example.com)
              </li>

              <li className="ml-6 text-lg">
                <strong>Google Dorking </strong> (e.g., site:example.com
                filetype:pdf)
              </li>

              <li className="ml-6 text-lg">
                <strong>DNS Enumeration </strong> using tools like{" "}
                <strong>Fierce</strong> or <strong>DNSRecon</strong>
              </li>
            </ul>

            <h2 id="network-scan" className="mt-2 mb-4 text-3xl font-semibold">
              3. Scanning
            </h2>

            <p className="mb-4 text-lg">
              Scanning is the process of probing a system or network to discover
              open ports, running services, and potential vulnerabilities.
            </p>

            <h2 id="network-scan" className="mt-2 mb-4 text-2xl font-semibold">
              Purpose:
            </h2>

            <p className="mb-4 text-lg">
              To find weak points in a system that can be exploited in later
              stages.
            </p>

            <h2 id="network-scan" className="mt-2 mb-4 text-2xl font-semibold">
              Common Techniques:
            </h2>

            <ul className="space-y-2 text-gray-800 list-disc list-inside">
              <li className="ml-6 text-lg">
                <strong>Port Scanning </strong>Identifying open ports.
              </li>

              <li className="ml-6 text-lg">
                <strong>Service Detection </strong> Finding out which services
                are running and their versions.
              </li>

              <li className="ml-6 text-lg">
                <strong>Vulnerability Scanning </strong> Detecting known
                vulnerabilities.
              </li>
            </ul>

            <h2 id="network-scan" className="mt-2 mb-4 text-2xl font-semibold">
              Popular Tools:
            </h2>

            <ul className="space-y-2 text-gray-800 list-disc list-inside">
              <li className="ml-6 text-lg">
                <strong>Nmap</strong>
              </li>

              <li className="ml-6 text-lg">
                <strong>OpenVAS</strong>
              </li>

              <li className="ml-6 text-lg">
                <strong>Nessus</strong>
              </li>
            </ul>

            <h2 id="network-scan" className="mt-2 mb-4 text-3xl font-semibold">
              4. Enumeration
            </h2>

            <p className="mb-4 text-lg">
              Enumeration involves active interaction with the target system to
              extract detailed information such as usernames, network shares,
              and configuration data.
            </p>

            <h2 id="network-scan" className="mt-2 mb-4 text-2xl font-semibold">
              Purpose:
            </h2>

            <p className="mb-4 text-lg">
              To gain deeper insight into the target's internal structure and
              potential access points.
            </p>

            <h2 id="network-scan" className="mt-2 mb-4 text-2xl font-semibold">
              Common Techniques:
            </h2>

            <ul className="space-y-2 text-gray-800 list-disc list-inside">
              <li className="ml-6 text-lg">
                <strong>NetBIOS Enumeration</strong>
              </li>

              <li className="ml-6 text-lg">
                <strong>SNMP Enumeration</strong>
              </li>

              <li className="ml-6 text-lg">
                <strong>LDAP Queries</strong>
              </li>

              <li className="ml-6 text-lg">
                <strong>SMTP VRFY command</strong>
              </li>
            </ul>

            <h2 id="network-scan" className="mt-2 mb-4 text-2xl font-semibold">
              Popular Tools:
            </h2>

            <ul className="space-y-2 text-gray-800 list-disc list-inside">
              <li className="ml-6 text-lg">
                <strong>Enum4linux</strong>
              </li>

              <li className="ml-6 text-lg">
                <strong>SNMPWalk</strong>
              </li>

              <li className="ml-6 text-lg">
                <strong>Nmap NSE Scripts</strong>
              </li>
            </ul>

            <h2 id="network-scan" className="mt-2 mb-4 text-3xl font-semibold">
              Tools and Technologies Used for Reconnaissance
            </h2>

            <ul className="space-y-2 text-gray-800 list-disc list-inside">
              <li className="ml-6 text-lg text-blue-700">
                <strong>
                  <a href="#whois">WHOIS</a>
                </strong>
              </li>

              <li className="ml-6 text-lg text-blue-700">
                <strong>
                  <a href="#virustotal">VirusTotal</a>
                </strong>
              </li>

              <li className="ml-6 text-lg text-blue-700">
                <strong>
                  <a href="#waybackmachine">Wayback Machine</a>
                </strong>
              </li>

              <li className="ml-6 text-lg text-blue-700">
                <strong>
                  <a href="#hunter.io">Hunter.IO</a>
                </strong>
              </li>

              <li className="ml-6 text-lg text-blue-700">
                <strong>
                  <a href="#mxtoolbox">MX toolbox</a>
                </strong>
              </li>

              <li className="ml-6 text-lg text-blue-700">
                <strong>
                  <a href="#dnschecker">DNSChecker</a>
                </strong>
              </li>

              <li className="ml-6 text-lg text-blue-700">
                <strong>
                  <a href="#shodan.io">Shodan.io</a>
                </strong>
              </li>

              <li className="ml-6 text-lg text-blue-700">
                <strong>
                  <a href="#ping">Ping</a>
                </strong>
              </li>

              <li className="ml-6 text-lg text-blue-700">
                <strong>
                  <a href="#nmap">Nmap</a>
                </strong>
              </li>

              <li className="ml-6 text-lg text-blue-700">
                <strong>
                  <a href="#wappalyzer">Wappalyzer</a>
                </strong>
              </li>

              <li className="ml-6 text-lg text-blue-700">
                <strong>
                  <a href="#urlfuzzer">Url Fuzzer</a>
                </strong>
              </li>
            </ul>

            <h2 id="whois" className="mt-4 mb-4 text-3xl font-semibold">
              WHOIS:
            </h2>

            <p className="mb-4 text-lg">
              WHOIS is a widely used Internet record listing that identifies who
              owns a domain and how to get in contact with it. The Internet
              Corporation for Assigned Names and Numbers (ICANN) regulates
              domain name registration and ownership. Who is records have proven
              to be extremely useful and have developed into an essential
              resource for maintaining the integrity of the domain name
              registration and website ownership process.
            </p>

            <figure className="mb-6 article-image">
              <img
                src={whoisImage}
                alt="https://www.whois.com"
                className="w-full rounded-lg"
              />
            </figure>

            <p className="mb-4 text-lg font-bold text-center hover:text-blue-600">
              <a
                href="https://www.whois.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.whois.com
              </a>
            </p>

            <h2 id="virustotal" className="mt-4 mb-4 text-3xl font-semibold">
              VirusTotal:
            </h2>

            <p className="mb-4 text-lg">
              VirusTotal was founded in 2004 as a free service that analyzes
              files and URLs for viruses, worms, trojans, and other kinds of
              malicious content. Our goal is to make the internet a safer place
              through collaboration between members of the antivirus industry,
              researchers, and end users of all kinds.
            </p>

            <figure className="mb-6 article-image">
              <img
                src={virustotalImage}
                alt="https://www.virustotal.com"
                className="w-full rounded-lg"
              />
            </figure>

            <p className="mb-4 text-lg font-bold text-center hover:text-blue-600">
              <a
                href="https://www.virustotal.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.virustotal.com
              </a>
            </p>

            <h2
              id="waybackmachine"
              className="mt-4 mb-4 text-3xl font-semibold"
            >
              Wayback Machine:
            </h2>

            <p className="mb-4 text-lg">
              The Internet Archive Wayback Machine is a service that allows
              people to visit archived versions of Web sites. Visitors to the
              Wayback Machine can type in a URL, select a date range, and then
              begin surfing on an archived version of the Web.
            </p>

            <figure className="mb-6 article-image">
              <img
                src={waybackImage}
                alt="https://web.archive.org"
                className="w-full rounded-lg"
              />
            </figure>

            <p className="mb-4 text-lg font-bold text-center hover:text-blue-600">
              <a
                href="https://web.archive.org"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://web.archive.org
              </a>
            </p>

            <h2 id="hunter.io" className="mt-4 mb-4 text-3xl font-semibold">
              Hunter.IO:
            </h2>

            <p className="mb-4 text-lg">
              Hunter.IO is an online service that offers various services for
              finding emails by name or phone number. It’s one of several
              similar services like Gmail Finder which can help you find your
              lost emails easily.
            </p>

            <figure className="mb-6 article-image">
              <img
                src={hunterImage}
                alt="https://hunter.io"
                className="w-full rounded-lg"
              />
            </figure>

            <p className="mb-4 text-lg font-bold text-center hover:text-blue-600">
              <a
                href="https://hunter.io"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://hunter.io
              </a>
            </p>

            <h2 id="mxtoolbox" className="mt-4 mb-4 text-3xl font-semibold">
              MX toolbox:
            </h2>

            <p className="mb-4 text-lg">
              MxToolbox supports global Internet operations by providing free,
              fast, and accurate network diagnostic and lookup tools. Millions
              of technology professionals use our tools to help diagnose and
              resolve a wide range of infrastructure issues.
            </p>

            <figure className="mb-6 article-image">
              <img
                src={mxToolboxImage}
                alt="https://mxtoolbox.com"
                className="w-full rounded-lg"
              />
            </figure>

            <p className="mb-4 text-lg font-bold text-center hover:text-blue-600">
              <a
                href="https://mxtoolbox.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://mxtoolbox.com
              </a>
            </p>

            <h2 id="dnschecker" className="mt-4 mb-4 text-3xl font-semibold">
              DNSchecker:
            </h2>

            <p className="mb-4 text-lg">
              DNSChecker is a free service providing users with fast and
              reliable DNS services, email-related lookups, and IP-related
              services for more than ten years.
            </p>

            <figure className="mb-6 article-image">
              <img
                src={dnsCheckerImage}
                alt="https://dnschecker.org"
                className="w-full rounded-lg"
              />
            </figure>

            <p className="mb-4 text-lg font-bold text-center hover:text-blue-600">
              <a
                href="https://dnschecker.org"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://dnschecker.org
              </a>
            </p>

            <h2 id="shodan.io" className="mt-4 mb-4 text-3xl font-semibold">
              Shodan.io:
            </h2>

            <p className="mb-4 text-lg">
              Shodan is a search engine that lets users search for various types
              of servers (webcams, routers, servers, etc.) connected to the
              internet using a variety of filters. Some have also described it
              as a search engine for service banners, which are metadata that
              the server sends back to the client. This can be information about
              the server software, what options the service supports, a welcome
              message, or anything else that the client can find out before
              interacting with the server.
            </p>

            <figure className="mb-6 article-image">
              <img
                src={shodanImage}
                alt="https://www.shodan.io"
                className="w-full rounded-lg"
              />
            </figure>

            <p className="mb-4 text-lg font-bold text-center hover:text-blue-600">
              <a
                href="https://www.shodan.io"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.shodan.io
              </a>
            </p>

            <h2 id="ping" className="mt-4 mb-4 text-3xl font-semibold">
              Ping:
            </h2>

            <p className="mb-4 text-lg">
              A ping (Packet Internet or Inter-Network Groper) is a basic
              Internet program that allows a user to test and verify if a
              particular destination IP address exists and can accept requests in
              computer network administration.
            </p>

            <figure className="mb-6 article-image">
              <img src={pingImage} alt="ping" className="w-full rounded-lg" />
            </figure>

            <h2 id="whatweb" className="mt-4 mb-4 text-3xl font-semibold">
              WhatWeb:
            </h2>

            <p className="mb-4 text-lg">
              The WhatWeb is a tool that is used to identify different web
              technologies including content management systems (CMS), blogging
              platforms, statistic/analytics packages, JavaScript libraries, web
              servers, and embedded devices.
            </p>

            <figure className="mb-6 article-image">
              <img
                src={whatWebImage}
                alt="WhatWeb"
                className="w-full rounded-lg"
              />
            </figure>

            <h2 id="nmap" className="mt-4 mb-4 text-3xl font-semibold">
              Nmap:
            </h2>

            <p className="mb-4 text-lg">
              Nmap (“Network Mapper”) is an open-source tool for network
              exploration and security auditing. It was designed to rapidly scan
              large networks, although it works fine against single hosts.
            </p>

            <figure className="mb-6 article-image">
              <img
                src={nmapImage}
                alt="WhatWeb"
                className="w-full rounded-lg"
              />
            </figure>

            <h2 id="Wappalyzer" className="mt-4 mb-4 text-3xl font-semibold">
              Wappalyzer
            </h2>

            <p className="mb-4 text-lg">
              Wappalyzer is a technology profiler used to extract information
              related to the technology stack of the target. If you want to find
              out what CMS or libraries the target is using and any framework,
              Wappalyzer is the tool to use.
            </p>

            <figure className="mb-6 article-image">
              <img
                src={wappalyzerImage}
                alt="WhatWeb"
                className="w-full rounded-lg"
              />
            </figure>

            <p className="mb-4 text-lg">
              There are different ways to use it — you can access information on
              the target by using the Lookup API. This method is mostly used by
              security engineers or InfoSec developers to integrate Wappalyzer as
              a technology profiler in a security product. Otherwise, you can
              install Wappalyzer as a browser extension for Chrome, Firefox, and
              Edge.
            </p>

            <h2 id="network-scan" className="mt-4 mb-4 text-3xl font-semibold">
              Find Folders and Files
            </h2>

            <p className="mb-4 text-lg">
              It is important to know which type of files or folders are hosted
              on the target web server in a pentest project. You will usually
              find sensitive information in files and folders such as
              administrator password, GitHub key, and so on a web server.
            </p>

            <h2 id="urlfuzzer" className="mt-4 mb-4 text-3xl font-semibold">
              URL Fuzzer:
            </h2>

            <p className="mb-4 text-lg">
              Url Fuzzer is an online service by Pentest-Tools. It uses a
              custom-built wordlist for discovering hidden files and directories.
              The wordlist contains more than 1000 common names of known files
              and directories.
            </p>

            <p className="mb-4 text-lg">
              It allows you to scan for hidden resources via a light scan or
              full scan. The full scan mode is only for registered users.
            </p>

            <figure className="mb-6 article-image">
              <img
                src={urlFuzzerImage}
                alt="https://pentest-tools.com"
                className="w-full rounded-lg"
              />
            </figure>

            <p className="mb-4 text-lg font-bold text-center hover:text-blue-600">
              <a
                href="https://pentest-tools.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://pentest-tools.com
              </a>
            </p>

            <p className="mb-4 text-lg">
              Pentest Tools got more than 20 tools for information gathering,
              website security testing, infrastructure scanning, and exploit
              helpers.
            </p>

            <h2 id="network-scan" className="mt-4 mb-4 text-3xl font-semibold">
              Conclusion:
            </h2>

            <p className="mb-4 text-lg">
              Information gathering is an art that every penetration-tester
              (pen-tester) and hacker should master for a better experience in
              penetration testing. It is a method used by analysts to determine
              the needs of customers and users.
            </p>
          </section>
        </article>

        {/* Right Section: Share Icon */}
        <button
          type="button"
          onClick={() => setShareModalOpen1(true)}
          className="mt-10 ml-2 text-2xl text-gray-700 cursor-pointer font-bild hover:text-black"
        >
          {/* Share Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-8 h-8 fill-current"
            viewBox="0 0 24 24"
          >
            <path
              fillRule="evenodd"
              d="M15.218 4.931a.4.4 0 0 1-.118.132l.012.006a.45.45 0 0 1-.292.074.5.5 0 0 1-.3-.13l-2.02-2.02v7.07c0 .28-.23.5-.5.5s-.5-.22-.5-.5v-7.04l-2 2a.45.45 0 0 1-.57.04h-.02a.4.4 0 0 1-.16-.3.4.4 0 0 1 .1-.32l2.8-2.8a.5.5 0 0 1 .7 0l2.8 2.79a.42.42 0 0 1 .068.498m-.106.138.008.004v-.01zM16 7.063h1.5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-11c-1.1 0-2-.9-2-2v-10a2 2 0 0 1 2-2H8a.5.5 0 0 1 .35.15.5.5 0 0 1 .15.35.5.5 0 0 1-.15.35.5.5 0 0 1-.35.15H6.4c-.5 0-.9.4-.9.9v10.2a.9.9 0 0 0 .9.9h11.2c.5 0 .9-.4.9-.9v-10.2c0-.5-.4-.9-.9-.9H16a.5.5 0 0 1 0-1"
              clipRule="evenodd"
            ></path>
          </svg>
        </button>
      </section>

      {/* Share Modal */}
      {shareModalOpen1 && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-opacity-50"
          onClick={(event) => {
            if (event.target === event.currentTarget) {
              setShareModalOpen1(false);
            }
          }}
        >
          <div className="p-6 text-black bg-gray-200 rounded-md w-80">
            <h2 className="mb-4 text-lg font-semibold">Share this article</h2>

            <div className="flex items-center justify-around">
              {/* X / Twitter */}
              <a
                href="https://twitter.com/intent/tweet?text=https://www.practicalinfosec.com/sqlInjection"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-blue-500"
              >
                <svg className="w-10 h-10 fill-current" viewBox="0 0 24 24">
                  <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53A4.48 4.48 0 0 0 22.43.36a9 9 0 0 1-2.83 1.08A4.52 4.52 0 0 0 16.11 0c-2.63 0-4.64 2.24-4.04 4.79A12.94 12.94 0 0 1 1.64 1.14a4.52 4.52 0 0 0-.61 2.27 4.5 4.5 0 0 0 2 3.75 4.41 4.41 0 0 1-2.06-.56v.06a4.53 4.53 0 0 0 3.63 4.43 4.52 4.52 0 0 1-2.04.08 4.53 4.53 0 0 0 4.22 3.14A9.05 9.05 0 0 1 0 19.54a12.93 12.93 0 0 0 7 2.05c8.4 0 13-7.5 12.68-14.23A9.18 9.18 0 0 0 23 3z" />
                </svg>
              </a>

              {/* Facebook */}
              <a
                href="https://www.facebook.com/sharer/sharer.php?u=https://www.practicalinfosec.com/sqlInjection"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-blue-700"
              >
                <svg className="w-8 h-8 fill-current" viewBox="0 0 24 24">
                  <path d="M22.675 0h-21.35C.592 0 0 .593 0 1.326v21.348C0 23.408.592 24 1.325 24H12.82V14.708h-3.293V11.17h3.293V8.413c0-3.26 1.986-5.038 4.89-5.038 1.39 0 2.585.104 2.933.15v3.4l-2.013.001c-1.577 0-1.883.75-1.883 1.85v2.43h3.766l-.491 3.538h-3.275V24h6.42C23.408 24 24 23.408 24 22.675V1.325C24 .593 23.408 0 22.675 0z" />
                </svg>
              </a>

              {/* LinkedIn */}
              <a
                href="https://www.linkedin.com/sharing/share-offsite/?url=https://www.practicalinfosec.com/sqlInjection"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-blue-600"
              >
                <svg className="w-8 h-8 fill-current" viewBox="0 0 24 24">
                  <path d="M20.447 20.452H17.24V14.8c0-1.345-.025-3.078-1.879-3.078-1.88 0-2.168 1.464-2.168 2.976v5.753h-3.207V9h3.076v1.561h.043c.429-.811 1.476-1.666 3.036-1.666 3.246 0 3.844 2.137 3.844 4.917v6.64zM5.337 7.433c-1.034 0-1.873-.839-1.873-1.874 0-1.034.839-1.873 1.873-1.873 1.036 0 1.875.839 1.875 1.873s-.839 1.874-1.875 1.874zM6.789 20.452H3.885V9h2.904v11.452zM22.225 0H1.771C.791 0 0 .77 0 1.723v20.555C0 23.23.79 24 1.771 24h20.451C23.21 24 24 22.278V1.723C24 .77 23.21 0 22.225 0z" />
                </svg>
              </a>
            </div>

            <button
              type="button"
              onClick={() => setShareModalOpen1(false)}
              className="block mx-auto mt-4 text-sm text-gray-600 underline hover:text-black"
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* Author Section */}
      <section className="max-w-5xl px-4 py-6 mx-auto mt-10 overflow-x-hidden rounded-lg">
        <div className="flex flex-col items-start gap-6 sm:flex-row">
          {/* Author Image */}
          <img
            src={authorImage}
            alt="Asman"
            className="object-cover w-24 h-24 rounded-lg"
          />

          {/* Author Info */}
          <div>
            <h3 className="mb-2 text-2xl font-semibold">Written by Asman</h3>

            <p className="mb-3 text-gray-700">Offensive Security Researcher.</p>

            <p className="text-gray-500 text-md">
              Published on <time dateTime="2023-02-11">June 18, 2025</time> •
              10 min read
            </p>
          </div>
        </div>
      </section>

      <section className="py-12 text-black bg-white">
        <div className="max-w-screen-xl px-4 mx-auto sm:px-4 lg:px-8">
          <div className="grid grid-cols-1 gap-6 sm:gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {/* Blog Card 1 */}
            <article
              className="transition duration-300 ease-in-out transform blog-card"
              data-category="WebApplicationSecurity"
            >
              <div className="overflow-hidden transition bg-gray-100 shadow rounded-xl hover:shadow-lg">
                <a href="sql-injection" target="_blank" rel="noopener noreferrer">
                  <img
                    className="object-cover w-full h-48"
                    src={sqlInjectionImage}
                    alt="SQL Injection"
                  />
                </a>

                <div className="p-5">
                  <div className="mb-2 text-sm text-black">
                    WebApplicationSecurity
                  </div>

                  <h3 className="mb-2 text-xl font-semibold">
                    Understanding SQL Injection: A Web Security Threat
                  </h3>

                  <p className="mb-4 text-sm text-black">
                    SQL Injection is a critical security flaw that allows
                    attackers to manipulate SQL queries, risking data breaches or
                    full database control.
                  </p>

                  <div className="flex justify-between text-sm font-semibold text-gray-700">
                    <span>May 03, 2025</span>
                    <span>7 min read</span>
                  </div>
                </div>
              </div>
            </article>

            {/* Blog Card 2 */}
            <article
              className="transition duration-300 ease-in-out transform blog-card"
              data-category="OWASPTop10"
            >
              <div className="overflow-hidden transition bg-gray-100 shadow rounded-xl hover:shadow-lg">
                <a
                  href="broken-access-control-authentication"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="object-cover w-full h-48"
                    src={brokenAccessImage}
                    alt="Broken Access Control Authentication"
                  />
                </a>

                <div className="p-5">
                  <div className="mb-2 text-sm text-black">OWASPTop10</div>

                  <h3 className="mb-2 text-xl font-semibold">
                    Broken Access Control & Auth: A Security Breakdown
                  </h3>

                  <p className="mb-4 text-sm text-black">
                    Broken Access Control and Authentication vulnerabilities are
                    critical security flaws that allow unauthorized users to gain
                    access to restricted areas.
                  </p>

                  <div className="flex justify-between text-sm font-semibold text-gray-700">
                    <span>May 02, 2025</span>
                    <span>5 min read</span>
                  </div>
                </div>
              </div>
            </article>

            {/* Blog Card 1 */}
            <article
              className="transition duration-300 ease-in-out transform blog-card"
              data-category="WebApplicationSecurity"
            >
              <div className="overflow-hidden transition bg-gray-100 shadow rounded-xl hover:shadow-lg">
                <a
                  href="session-management"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="object-cover w-full h-48"
                    src={sessionImage}
                    alt="Session Management"
                  />
                </a>

                <div className="p-5">
                  <div className="mb-2 text-sm text-black">
                    WebApplicationSecurity
                  </div>

                  <h3 className="mb-2 text-xl font-semibold">
                    Secure Session Management: Best Practices & Techniques
                  </h3>

                  <p className="mb-4 text-sm text-black">
                    Session management is secure for user authentication in web
                    applications. Techniques to prevent session-related threats
                    like hijacking and fixation.
                  </p>

                  <div className="flex justify-between text-sm font-semibold text-gray-700">
                    <span>Apr 28, 2025</span>
                    <span>5 min read</span>
                  </div>
                </div>
              </div>
            </article>

            {/* Repeat your blog cards here (already responsive) */}
          </div>
        </div>
      </section>

      {/* WhatsApp Sticky Button */}
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
          setWhatsappOpen((prev) => !prev);
        }}
        className="fixed z-50 p-3 px-4 text-white transition -translate-y-1/2 rounded-full shadow-lg cursor-pointer top-1/2 right-6 animate-blink hover:opacity-90 bg-gradient-to-r from-green-400 via-green-500 to-green-600"
        aria-label="Join WhatsApp"
      >
        <i className="text-4xl fa-brands fa-whatsapp"></i>
      </button>

      {/* WhatsApp Modal */}
      {whatsappOpen && (
        <div
          className="fixed z-50 p-4 transition-opacity duration-300 -translate-y-1/2 bg-white shadow-xl top-1/2 right-20 rounded-xl w-72 max-sm:right-4 max-sm:left-4 max-sm:w-auto"
          role="dialog"
          aria-modal="true"
          aria-labelledby="whatsappTitle"
        >
          {/* Close Button */}
          <button
            type="button"
            onClick={(event) => {
              event.stopPropagation();
              setWhatsappOpen(false);
            }}
            className="absolute text-3xl text-gray-600 cursor-pointer top-2 left-4 hover:text-red-500"
            aria-label="Close"
          >
            &times;
          </button>

          <h2
            id="whatsappTitle"
            className="mt-6 mb-2 text-lg font-bold text-center text-gray-800"
          >
            Unsure about which course to choose?
          </h2>

          <p className="mb-3 text-sm text-center text-gray-700">
            Tap below to start a WhatsApp chat — we're here to help!
          </p>

          {/* Action buttons */}
          <div className="flex flex-col items-center gap-3">
            {/* Chat Now (wa.me URL works on mobile + desktop) */}
            <button
              type="button"
              onClick={openWhatsAppChat}
              className="inline-flex items-center justify-center w-full gap-2 px-3 py-2 text-sm text-white transition bg-green-600 rounded-full hover:bg-green-700"
              aria-label="Chat Now on WhatsApp"
            >
              <i className="fa-brands fa-whatsapp"></i>
              Chat Now
            </button>

            {/* Open in App (deep link) */}
            <button
              type="button"
              onClick={openWhatsAppAppFallback}
              className="inline-flex items-center justify-center w-full gap-2 px-3 py-2 text-sm text-gray-800 transition border border-gray-200 rounded-full hover:bg-gray-50"
              aria-label="Open in WhatsApp App"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4 text-green-600"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M20.52 3.48A11.93 11.93 0 0012 .5C5.73.5.99 5.24.99 11.5c0 2.01.53 3.95 1.53 5.68L0 24l6.97-1.79c1.61.45 3.28.68 4.9.68 6.27 0 11.01-4.74 11.01-11 0-3.02-1.18-5.85-3.36-7.41zM12 21.5c-1.44 0-2.86-.34-4.14-.99l-.3-.15-4.14 1.06 1.15-3.98-.18-.31A8.12 8.12 0 013 11.5c0-4.97 4.06-9 9-9 2.41 0 4.66.94 6.36 2.64a8.95 8.95 0 012.64 6.36c0 4.97-4.06 9-9 9z" />
              </svg>
              Open in App
            </button>
          </div>
        </div>
      )}

      {/* Back to Top Button */}
      {showBackToTop && (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed z-50 p-4 text-white transition bg-blue-700 rounded-lg shadow-lg cursor-pointer bottom-12 right-7 hover:bg-blue-700"
          aria-label="Back to top"
        >
          {/* Up Arrow Icon */}
          <i className="text-xl fa-solid fa-arrow-up"></i>
        </button>
      )}

      {/* Floating Call Button */}
      <a
        href="tel:+91-9080432374"
        className="fixed z-50 p-3 text-white transition rounded-md shadow-lg cursor-pointer bg-violet-600 bottom-60 right-7 hover:bg-green-700"
        aria-label="Call Us"
      >
        {/* Phone Icon */}
        <i className="text-2xl fa-solid fa-phone"></i>
      </a>
    </main>
  );
}

export default ReconnaissanceInPenetrationTesting;